import { bootstrap } from './bootstrap';
import { handleSystemCrash } from './crash';

bootstrap().catch(handleSystemCrash);
